export class CONSTANT_VALUES {
  public static SIGNIN_SUCCESS = 'sign in successfully';
  public static SIGNUP_SUCCESS = 'sign up successfully';
  public static RESPONSE_SUCCESS = 'SUCCESS';
  public static RESPONSE_ERROR = 'ERROR';

  public static FACILITY_TYPE = ['Sports', 'Amenities', 'Dining', 'Classes', 'Diagnostics', 'Doctor\'s Booking', 'Dr Julian Png', 'Consulting', 'Group Classes', 'Trainers', 'Introductory Session', 'Facial', 'Hair Removal', 'Hair Styling - Men', 'Massage', 'Nail Treatment', 'Other services', 'Hair Styling - Women', 'Table Reservation', 'Deliveries', 'Events', 'Sunday Brunch', 'Seven Kitchens', 'The Kipling Bar', 'By The Mekong', 'Yuuka', 'The St Regis Bar', 'Luna', 'XXO', 'ASILO', 'Restaurants', 'Bars', 'Nightlife', 'SPA', 'Wellness', 'Iridium SPA', 'The Salon', 'Business Centre', 'Meeting Rooms', 'Rituals', 'The St Regis Athletics Club', 'Couple SPAce', 'Just for Men', 'Spa Packages', 'Body Treatments', 'Express Packages', 'SPAce Detan Treatments', 'Deals or Promotions', 'Others'];
  public static EVENT_TYPE = ['Events'];
  public static LINK_TYPE = ['Links'];
  public static BOOKING_TYPE = ['Group Classes'];

  public static BROADCAST_SEND_TO = ['All Members', 'All Groups', 'Specific Members', 'Specific Groups'];
  public static ICON_LIST = ['Cafe', 'Football', 'Golf', 'Mountroom', 'Parking', 'Restobar', 'Scuba', 'Splashbar',
    'Windsor', 'Tennis', 'Functionhall', 'Swimming', 'Cricket', 'Squash'];
  public static ENTRIES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
  public static HOLDBOOKINGDAYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13',
    '14', '15', '16', '17', '18', '19', '20'];
  public static COLOR = ['#898F27', '#C8731F', '#994659', '#1F86C8', '#2DADB2', '#B58F1A', '#983339', '#271511',
    '#D75D14', '#792D11', '#CB8517', '#3E4EAE', '#0D9268', '#3E3F2c'];
  public static MAX_PEOPLE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
    11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
    31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
    51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
    61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
    71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
    81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    91, 92, 93, 94, 95, 96, 97, 98, 99, 100];
  public static NOTIFICATION_PERIOD = [0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
  public static UNIT_LIST = [1, 2, 3, 4, 5, 6];
  public static TIMINGS = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00',
    '07:00', '08:00', '09:00', '10:00', '11:00', '12:00',
    '13:00', '14:00', '15:00', '16:00', '17:00', '18:00',
    '19:00', '20:00', '21:00', '22:00', '23:00'];
  public static TIMINGS_END = ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00',
    '07:00', '08:00', '09:00', '10:00', '11:00', '12:00',
    '13:00', '14:00', '15:00', '16:00', '17:00', '18:00',
    '19:00', '20:00', '21:00', '22:00', '23:00'];
  public static AMENITIES = ['Amenities', 'Trainers', 'Introductory Session', 'Diagnostics', 'Consulting'];
  public static SPORTS = ['Sports', 'Classes', 'Dining', 'Doctor\'s Booking', 'Dr Julian Png', 'Group Classes', 'Facial', 'Hair Removal', 'Hair Styling - Men', 'Massage', 'Nail Treatment', 'Other services', 'Hair Styling - Women', 'Table Reservation', 'Deliveries', 'Events', 'Sunday Brunch', 'Seven Kitchens', 'The Kipling Bar', 'By The Mekong', 'Yuuka', 'The St Regis Bar', 'Luna', 'XXO', 'ASILO', 'Restaurants', 'Bars', 'Nightlife', 'SPA', 'Wellness', 'Iridium SPA', 'The Salon', 'Business Centre', 'Meeting Rooms', 'Rituals', 'The St Regis Athletics Club', 'Couple SPAce', 'Just for Men', 'Spa Packages', 'Body Treatments', 'Express Packages', 'SPAce Detan Treatments', 'Deals or Promotions', 'Others'];
  public static ICON_LIST_IMAGE = [{ 'name': 'cafe', 'title': 'Verandah Cafe', 'iconClass': 'icon-verandah-cafe' },
  { 'name': 'football', 'title': 'Football', 'iconClass': 'icon-football' },
  { 'name': 'golf', 'title': 'Golf', 'iconClass': 'icon-golf' },
  { 'name': 'mountroom', 'title': 'Mountbatten Room', 'iconClass': 'icon-dining' },
  { 'name': 'parking', 'title': 'Parking', 'iconClass': 'icon-parking' },
  { 'name': 'restobar', 'title': 'Restobar', 'iconClass': 'icon-dining' },
  { 'name': 'scuba', 'title': 'Scuba Diving', 'iconClass': 'icon-scuba-diving' },
  { 'name': 'splashbar', 'title': 'Splash Bar', 'iconClass': 'icon-splashbar' },
  { 'name': 'windsor', 'title': 'Windsor', 'iconClass': 'icon-windsor-arms' },
  { 'name': 'tennis', 'title': 'Tennis', 'iconClass': 'icon-tennis' },
  // { 'name': 'functionhall', 'url': '../assets/images/icn_hall_grey.svg', 'title': 'Function Hall', 'iconClass': 'icon-hall' },
  { 'name': 'amenities', 'title': 'Amenities', 'iconClass': 'icon-shape' },
  { 'name': 'swimming', 'title': 'Swimming', 'iconClass': 'icon-swimming' },
  { 'name': 'cricket', 'title': 'Cricket', 'iconClass': 'icon-cricket' },
  { 'name': 'squash', 'title': 'Squash', 'iconClass': 'icon-squash' },
  { 'name': 'yoga', 'title': 'Yoga', 'iconClass': 'icon-yoga-white' },
  { 'name': 'dance', 'title': 'Dance', 'iconClass': 'icon-zumba-white' },
  { 'name': 'boat', 'title': 'Boat', 'iconClass': 'icon-sailboat-white' },
  { 'name': 'chemistry', 'title': 'Chemistry', 'iconClass': 'icon-chemistry' },
  { 'name': 'physics', 'title': 'Physics', 'iconClass': 'icon-physics-white' },
  { 'name': 'book', 'title': 'Book', 'iconClass': 'icon-book' },
  { 'name': 'barbieque', 'title': 'Barbeque', 'iconClass': 'icon-bbq' },
  { 'name': 'other', 'title': 'Other', 'iconClass': 'icon-facility' },
  { 'name': 'other1', 'title': 'Other', 'iconClass': 'icon-otherfacility' },
  { 'name': 'facial', 'title': 'Facial', 'iconClass': 'icon-facial' },
  { 'name': 'hairRemoval', 'title': 'Hair Removal', 'iconClass': 'icon-hair_removal' },
  { 'name': 'hairStylingMen', 'title': 'Hair Styling Men', 'iconClass': 'icon-mens_hair' },
  { 'name': 'massage', 'title': 'Massage', 'iconClass': 'icon-massage' },
  { 'name': 'nailTreatment', 'title': 'Nail Treatment', 'iconClass': 'icon-manicure' },
  { 'name': 'otherServices', 'title': 'Other Services', 'iconClass': 'icon-other_services' },
  { 'name': 'hairStylingWomen', 'title': 'Hair Styling Women', 'iconClass': 'icon-womens_hair' }
  ];

  public static MEMBER_TYPE = ['Unspecified', 'Staff'];
  public static VALIDATOR_CLASS_NAME = 'required';
  // public static AMENITIES_CATEGORY = 'Amenities';
  public static TRAINER_CATEGORY = 'Trainers';
  public static PERSONALTRAINER_CATEGORY = 'Personal Training';
  public static TOGGLE_BUTTON_SET = 'btn btn-primary btn-toggle1';
  public static TOGGLE_BUTTON_UN_SET = 'btn btn-primary btn-toggle2';
  public static CATEGORY_LIST_FOR_FEED = ['BROADCAST', 'ALERT'];
  public static SUPER_ADMIN = 'superAdmin';
  public static AMENETIES_SLOT = 60;

  public static BOOKING_STATUS = [
    { type: 'confirmBooking', status: 'Booked', values: true },
    { type: 'waitlistBooking', status: 'Waitlist', values: true },
    { type: 'paymentPending', status: 'Booking Pending', values: true },
    { type: 'cancelledBooking', status: 'Cancelled', values: true },
    { type: 'walkInBooking', status: 'Walkin-booking', values: true }
    // {type : 'forcedBooking' , status : 'Force Bookings' , values : true},
    // {type : 'offlineBooking' , status : 'On Boarding Booking' , values : true},
  ];

  public static BOOKING_UNIT = ['00:15', '00:30', '00:45', '01:00',
    '01:15', '01:30', '01:45', '02:00', '02:15', '02:30', '02:45', '03:00'];
  public static HOUR_VALUES = ['00', '01', '02', '03', '04', '05',
    '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
  public static HOUR_VALUES_ACTIVITY_END_TIME = ['00', '01', '02', '03', '04', '05',
    '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
  public static MINUTE_VALUES = ['00', '15', '30', '45'];
  // Authentication

  public static URL_VENDOR_SIGN_IN = '/api/vendors/signin';
  public static URL_VENDOR_CREATE = '/api/vendors';
  public static URL_FORGOT_PASSWORD = '/api/vendors/forgotPassword';
  public static CHANGE_PASSWORD = '/api/vendors/updatepassword';
  public static VENDOR_DETAILS = '/api/vendors/getvendordetails';
  public static VENDOR_EDIT = '/api/vendors/updateVendorDetails'

  // Facility
  public static URL_FACILITY_LIST_BY_VENDOR = '/api/facility/getclubfacilitybyvendor';
  public static URL_CREATE_OR_UPDATE_FACILITY = '/api/facility';
  public static URL_DELETE_FACILITY = '/api/facility/deletefacility';

  // Feed

  public static URL_CREATE_FEED = '/api/feeds/create';
  public static URL_GET_FEDD_HISTORY = '/api/feeds/history';

  // Feedback
  public static URL_GET_FEEDBACK_LIST = '/api/feedback/getbyvendor';
  public static URL_UPDATE_FEEDBACK = '/api/feedback';
  public static URL_FEEDBACK_REPLY = '/api/feedback/respond';
  public static URL_FEEDBACK_FORWARD = '/api/feedback/forward';
  public static GET_CATEGORIES_FOR_FEEDBACK = '/api/feedback/getallcategories';

  // group

  public static URL_GET_GROUP_MEMBERS = '/api/group/getgroupmembers';
  public static URL_CREATE_GROUP = '/api/group/create';
  public static URL_GET_MEMBERS_NOT_IN_GROUP = '/api/group/notingroupmembers';
  public static URL_UPDATE_GROUP = '/api/group/update';
  public static URL_GET_MEMBERS_IN_GROUP = '/api/group/getgroupmembers';
  public static URL_REMOVE_MEMBERS_FROM_GROUP = '/api/group/removemembers';
  public static URL_ADD_MEMBERS_IN_GROUP = '/api/group/addmembers';
  public static URL_GET_FACILITY_LIST_VENDOR = '/api/facility/getfacilitiesbyvendor';
  public static URL_ACTION_ON_GROUP = '/api/group/groupaction';
  public static URL_DELETE_GROUP = '/api/group/delete';
  public static URL_ALL_GROUP = '/api/group/getallgroups';
  //member
  public static URL_GET_MEMBER_VENDOR = '/api/vendors/getMemberList';
  public static URL_GET_STAFF_VENDOR = '/api/staffs/all';
  public static URL_ADD_MEMBER = '/api/vendors/addmember';
  public static URL_ADD_STAFF = '/api/staffs';
  public static URL_DELETE_USER = '/api/vendors/deleteuser';
  public static URL_DISABLE_MEMBER = '/api/users/disable';
  public static URL_UPDATE_MEMBER = '/api/vendors/updatemember';
  public static URL_UPDATE_STAFF = '/api/staffs';
  public static URL_RESEND_CODE = '/api/vendors/resendcode';
  public static URL_RESEND_INVITE = '/api/staffs/resendmail';
  public static URL_DEACTIVATE_USER = '/api/users/deactivate';
  public static URL_GET_ENABLE_MEMBER_LIST = '/api/vendors/getfilteredmembers';
  public static URL_ENABLE_MEMBER = '/api/users/enable';
  public static URL_GET_VENDOR_BY_ID = '/api/vendors/findbyid';
  public static URL_GET_ACTIVATE_USER = '/api/users/activate';
  public static URL_GET_DEACTIVATE_USER = '/api/users/deactivate';
  public static URL_GET_MEMBER_DETAIL = '/api/vendors/getuserdetails';
  public static URL_GET_MASTER_DATA_DETAIL = '/api/masterdata/details';

  //calendar
  public static URL_GET_BOOKINGS_FACILITY = '/api/users/bookingbyfacility';
  public static URL_MAKE_PAYMENT = '/api/vendors/markpaymentdone';
  public static URL_BOOK_FACILITY = '/api/users/bookfacility';
  public static URL_GET_MEMBER_BY_MEMBERSHIP_ID = '/api/vendors/getvendormembers';
  public static URL_CANCEL_BOOKING = '/api/users/cancelbooking';
  public static URL_BOOK_COURT = '/api/users/bookingbycourt';
  public static URL_BOOKINGS_BY_COURT = '/api/vendors/getbookingsummary';
  public static URL_ADD_MEMBER_WITH_BOOKING = '/api/vendors/addmemberwithbooking';
  public static URL_BLOCK_DATES = '/api/facility/blockdates';
  public static URL_MARK_BOOKINGS_AS_VISITED = '/api/users/markasvisited';
  public static DELETE_MULTIPLE_BOOKINGS = '/api/vendors/deletemultiplebookings';
  public static URL_UNBLOCK_DATES = '/api/facility/unblockDates';
  public static URL_REPEAT_BOOKING = '/api/vendors/repeatBooking'
  public static URL_GENERATE_INVOICE = '/api/bookings/generateInvoice';
  // on-boarding
  public static URL_UPLOAD_MEMBER = "/api/vendors/uploadmembers";
  public static URL_SEND_MAIL = "/api/vendors/resendcode";
  public static URL_UPLOAD_BOOKING = '/api/users/uploadbookings';

  // Loyalty
  public static URL_MEMBER_VISIT_STATS = '/api/member-visit/stats';
  public static URL_CREATE_MEMBER_VISIT = '/api/member-visit/create';
  public static URL_MEMBER_VISIT_PER_FACILITY = '/api/member-visit/get-visits-per-facility';
  public static URL_MEMBER_VISIT_DETAILS = '/api/member-visit/get-member-visit-details';
  public static URL_MEMBER_VISIT_TOTAL_SPENT = '/api/member-visit/update-total-spent';

  public static CSV_STRUCTURE_MEMBER = ['Email Id', 'Country Code', 'Contact Number', 'Membership Id', 'First Name', 'Last Name', 'Type'];
  public static CSV_STRUCTURE_BOOKING = ['Membership Id', 'Country Code', 'Contact Number', 'Facility Name', 'Category', 'Booking Date', 'Start Time', 'End Time', 'Unit Name', 'Attendees'];
  public static CSV_STRUCTURE_BLOCK_SLOTS = ['Category', 'Activity', 'Unit Name', 'Start Date', 'End Date', 'Entire Day', 'Start Time', 'End Time', 'No of Times'];

  public static currency = '$';
  public static DEVICE_TYPE = 'web';
  public static ROLE_VENDOR_ADMIN = 'vendor admin';
  public static ROLE_STAFF = 'staff';
  public static SALT_FOR_HASHING = '$2a$16$/0cd15MPS32IgxmeC7heje';

  // Account
  public static URL_PAYMENT_HISTORY = '/api/bookings/getpaymenthistory';
  public static URL_GENERATE_PENALTY_INVOICE = '/api/penalty/generatepenaltyinvoice';
  public static URL_SEND_INVOICE = '/api/penalty/sendpenaltynotification';
  public static URL_GET_PENDING_INVOICES = '/api/penalty/getpendinginovoice';
  public static URL_PENALTY_PAYMENT = '/api/penalty/markpenaltypaymentdone';
  public static LOG = {
    'membershipId': 'membership id is not mentioned',
    'contactNumber': 'contact number is not mentioned',
    'emailId': 'email id is not mentioned',
    'firstName': 'first name is not mentioned',
    'lastName': 'last name is not mentioned',
    'type': 'type is not mentioned',
    'inValidContactNumber': 'contactnumber is not valid',
    'contactNumberLength': 'contact number length should be minimum 4 and maximum 16',
    'contactNumberDuplicate': 'contact number mentioned already exists',
    'invalidEmailId': 'email id mentioned is invalid',
    'category': 'category is not mentioned',
    'startTime': 'startTime is not mentioned',
    'endTime': 'endTime is not mentioned',
    'unitName': 'unit name is not mentioned',
    'InValidFacilityName': 'Facility name is invalid',
    'InValidCategoryName': 'Category name is invalid',
    'attendeesCount': 'Attendees should be numerical value',
    'bookingDate': 'Booking date is not mentioned',
    'InvalidBookingDateFormat': 'Booking date has not proper format',
    'InvalidBookingDate': 'Booking date or time is invalid',
    'countryCode': 'Country code is not mentioned',
    'InvalidCountryCode': 'Invalid country code',
    'invalidMembershipId': 'Membership Id can accept combination of Numbers, Alphabets and these special characters ( such as -, _ and /)',
    'group': 'Groups is not mentioned',
    'note': 'Note is not mentioned'
  };
  public static MEMBER_CSV_PATH = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-development/general/Member.csv';
  public static BOOKING_CSV_PATH = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-development/general/Booking.csv';

  public static MEMBER_CSV_PATH_QA = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-qa/general/Member.csv';
  public static BOOKING_CSV_PATH_QA = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-qa/general/Booking.csv';

  public static MEMBER_CSV_PATH_UAT = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-demo/general/Member.csv';
  public static BOOKING_CSV_PATH_UAT = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-demo/general/Booking.csv';

  public static MEMBER_CSV_PATH_PROD = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-production/general/Member.csv';
  public static BOOKING_CSV_PATH_PROD = 'https://s3-ap-southeast-1.amazonaws.com/marquisa-production/general/Booking.csv';

  // External Provider API Configuration
  static readonly EXTERNAL_PROVIDER_API_SCHEMA = {
    enabled: true,
    provider: 'Digirestro',
    digirestro: {
      baseUrl: 'https://appserverv8.digirestro.in/hungryuat/api/integration',
      apiKey: '6bc43184-b4e1-4ced-bd04-076ce7d21403',
      browserUrl: 'https://nice-ocean-0bb5f4300.1.azurestaticapps.net',
      integrationId: 1,
      storeId: 7
    }
  };

  // External API Providers List
  public static readonly EXTERNAL_API_PROVIDERS = ['Shopify', 'Digirestro', 'Custom'];

  // Digirestro Field Labels
  public static readonly DIGIRESTRO_FIELDS = {
    BROWSER_URL_LABEL: 'Browser URL',
    BROWSER_URL_DESCRIPTION: 'The browser URL for the Digirestro integration frontend',
    INTEGRATION_ID_LABEL: 'Integration ID',
    INTEGRATION_ID_DESCRIPTION: 'The unique integration identifier for Digirestro',
    BASE_URL_LABEL: 'Base URL',
    BASE_URL_DESCRIPTION: 'The API base URL for Digirestro server',
    API_KEY_LABEL: 'API Key',
    API_KEY_DESCRIPTION: 'Your Digirestro API authentication key',
    STORE_ID_LABEL: 'Store ID',
    STORE_ID_DESCRIPTION: 'The unique identifier for your store'
  };

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/constants/constant-values.ts